import React, { useState } from "react";
import { MapPin, Crosshair } from "lucide-react";
import { toast } from "sonner";

export default function GpsField({ latitude, longitude, onChange }) {
  const [busy, setBusy] = useState(false);

  const capture = () => {
    if (!navigator.geolocation) {
      toast.error("GPS not available on this device");
      return;
    }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        onChange(parseFloat(pos.coords.latitude.toFixed(6)), parseFloat(pos.coords.longitude.toFixed(6)));
        setBusy(false);
        toast.success("Location captured");
      },
      (err) => {
        setBusy(false);
        toast.error(err.message || "Could not get location");
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  return (
    <div className="space-y-2" data-testid="gps-field">
      <button
        type="button"
        onClick={capture}
        disabled={busy}
        className="inline-flex items-center gap-2 h-11 px-4 rounded-md bg-white border border-brand-border hover:bg-brand-surfaceAlt text-sm font-medium transition-colors disabled:opacity-60"
        data-testid="gps-capture-btn"
      >
        <Crosshair className="h-4 w-4 text-brand-primary" />
        {busy ? "Locating…" : latitude && longitude ? "Refresh GPS" : "Capture GPS"}
      </button>
      <div className="grid grid-cols-2 gap-3">
        <input
          type="number"
          step="any"
          placeholder="Latitude"
          value={latitude ?? ""}
          onChange={(e) => onChange(e.target.value === "" ? null : parseFloat(e.target.value), longitude)}
          className="h-11 px-3 rounded-md bg-brand-surfaceAlt border border-brand-border focus:bg-white focus:ring-2 focus:ring-brand-primary outline-none"
          data-testid="gps-lat"
        />
        <input
          type="number"
          step="any"
          placeholder="Longitude"
          value={longitude ?? ""}
          onChange={(e) => onChange(latitude, e.target.value === "" ? null : parseFloat(e.target.value))}
          className="h-11 px-3 rounded-md bg-brand-surfaceAlt border border-brand-border focus:bg-white focus:ring-2 focus:ring-brand-primary outline-none"
          data-testid="gps-lng"
        />
      </div>
      {latitude && longitude && (
        <div className="text-xs text-brand-muted inline-flex items-center gap-1">
          <MapPin className="h-3.5 w-3.5 text-brand-accent" /> {latitude}, {longitude}
        </div>
      )}
    </div>
  );
}
